import { AxiosError } from "axios";
import { client } from "api";
import { OrderFile } from "models/OrderFile";

export type GetOrderFilesRequest = string;

export type GetOrderFilesResponse = OrderFile[];

export const getOrderFiles = (orderId: GetOrderFilesRequest) =>
  client
    .get<GetOrderFilesResponse>(`/order/${encodeURIComponent(orderId)}/files`)
    .then((res) => res.data)
    .catch((e: AxiosError) => {
      // 404 means the order has no files in Pyramid. Treat as empty.
      if (e.response?.status === 404) {
        return [] as GetOrderFilesResponse;
      }
      throw e;
    });
